import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';
import { EmbeddedHostV2 } from './embedded-host';

/**
 * IPsec Tunneler entity (CloudZiti V8 / V3 API).
 *
 * Pairs a strongSwan IPsec responder with an OpenZiti tunneler on a single AWS EC2 VM.
 * 1:1 with a customer tunnel — one VM, one SA, one peer.
 *
 * Backed by core-management's IpsecTunnelerV3Controller at
 * /v3/networks/{networkId}/ipsec-tunnelers.
 */
@HateoasResource('ipsec-tunnelers', { routeName: 'networkResourceRoute' })
export class IpsecTunnelerV2 extends Resource {
    id: string;
    networkId: string;
    name: string;
    status: string;
    online: boolean;

    // Identity / placement
    attributes: string[];
    region: string;
    size: string;
    provider: string;

    // Customer peer
    customerPublicIp: string;

    customerPeerCidrs: string[];

    // Ziti tunneler-role endpoint identity (auto-named ${name}-tunneler)
    zitiEndpointIdentityId: string;

    // PSK (write-only, server-generated; surfaced once on create response)
    pskStoredSecretId: string;
    pskRevealedOnce?: string;

    ikeProposals: string[];
    espProposals: string[];

    // Host / VM details (mirrors EdgeRouterV2.host).
    hostId: string;
    host: EmbeddedHostV2;

    // Audit
    createdAt: string;
    updatedAt: string;
    createdBy: string;

    // UI state
    selected = false;
}
